import { render, staticRenderFns } from "./DailyTasks.vue?vue&type=template&id=2a3c5394&scoped=true"
import script from "./DailyTasks.vue?vue&type=script&lang=js"
export * from "./DailyTasks.vue?vue&type=script&lang=js"
import style0 from "./DailyTasks.vue?vue&type=style&index=0&id=2a3c5394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c5394",
  null
  
)

export default component.exports